Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompositeAggsQuery = exports.getAggsQuery = exports.extractQueryFromDefaultQuery = exports.updateInternalQuery = exports.getSearchState = exports.getOptionsFromQuery = exports.parseHits = exports.handleA11yAction = exports.getInnerKey = exports.getClassName = exports.checkSomePropChange = exports.checkPropChange = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.isEqual = isEqual;
exports.debounce = debounce;
exports.getQueryOptions = getQueryOptions;
exports.buildQuery = buildQuery;
exports.pushToAndClause = pushToAndClause;
exports.checkValueChange = checkValueChange;
exports.getAggsOrder = getAggsOrder;
exports.formatDate = formatDate;

var _dateFormats = require('./dateFormats');

var _dateFormats2 = _interopRequireDefault(_dateFormats);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function isEqual(x, y) {
  if (x === y) return true;
  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  if (x.constructor !== y.constructor) return false;

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    if (!y.hasOwnProperty(p)) return false;
    if (x[p] === y[p]) continue;
    if (typeof x[p] !== 'object') return false;
    if (!isEqual(x[p], y[p])) return false;
  }

  for (var _p in y) {
    if (y.hasOwnProperty(_p) && !x.hasOwnProperty(_p)) return false;
  }

  return true;
}

function debounce(callback, wait) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
  var timeout = null;
  var callbackArgs = null;

  var later = function later() {
    return callback.apply(context, callbackArgs);
  };

  return function debouncedFunction() {
    callbackArgs = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function getQueryOptions(props) {
  var options = {};

  if (props.size !== undefined) {
    options.size = props.size;
  }

  if (props.includeFields || props.excludeFields) {
    var source = {};

    if (props.includeFields) {
      source.includes = props.includeFields;
    }

    if (props.excludeFields) {
      source.excludes = props.excludeFields;
    }

    options._source = source;
  }

  return options;
}

function getOperation(conjunction) {
  if (conjunction === 'and') {
    return 'must';
  }

  if (conjunction === 'or') {
    return 'should';
  }

  return 'must_not';
}

function createBoolQuery(operation, query) {
  var resultQuery = null;

  if (Array.isArray(query) && query.length || !Array.isArray(query) && query) {
    resultQuery = {
      bool: _defineProperty({}, operation, query)
    };
  }

  if (operation === 'should' && resultQuery) {
    resultQuery = {
      bool: _extends({}, resultQuery.bool, {
        minimum_should_match: 1
      })
    };
  }

  return resultQuery;
}

function getQuery(react, queryList) {
  var query = [];
  Object.keys(react).forEach(function (conjunction) {
    if (Array.isArray(react[conjunction])) {
      var operation = getOperation(conjunction);
      var queryArr = react[conjunction].map(function (comp) {
        if (typeof comp !== 'string') {
          return getQuery(comp, queryList);
        } else if (comp in queryList) {
          return queryList[comp];
        }

        return null;
      }).filter(function (item) {
        return !!item;
      });
      var boolQuery = createBoolQuery(operation, queryArr);

      if (boolQuery) {
        query = [].concat(_toConsumableArray(query), [boolQuery]);
      }
    } else if (typeof react[conjunction] === 'string') {
      var _operation = getOperation(conjunction);

      var _boolQuery = createBoolQuery(_operation, queryList[react[conjunction]]);

      if (_boolQuery) {
        query = [].concat(_toConsumableArray(query), [_boolQuery]);
      }
    } else if (typeof react[conjunction] === 'object' && react[conjunction] !== null) {
      var _boolQuery2 = getQuery(react[conjunction], queryList);

      if (_boolQuery2) {
        query = [].concat(_toConsumableArray(query), [_boolQuery2]);
      }
    }
  });

  if (Array.isArray(query) && query.length) {
    return {
      bool: {
        must: query
      }
    };
  }

  if (query && Object.keys(query).length) {
    return query;
  }

  return null;
}

function getExternalQueryOptions(react, options, component) {
  var queryOptions = {};
  Object.keys(react).forEach(function (conjunction) {
    if (Array.isArray(react[conjunction])) {
      react[conjunction].forEach(function (comp) {
        if (options[comp]) {
          queryOptions = _extends({}, queryOptions, options[comp]);
        }
      });
    } else if (typeof react[conjunction] === 'string') {
      if (options[react[conjunction]]) {
        queryOptions = _extends({}, queryOptions, options[react[conjunction]]);
      }
    } else if (typeof react[conjunction] === 'object' && react[conjunction] !== null && !Array.isArray(react[conjunction])) {
      queryOptions = _extends({}, queryOptions, getExternalQueryOptions(react[conjunction], options));
    }
  });

  if (options[component]) {
    queryOptions = _extends({}, queryOptions, options[component]);
  }

  return queryOptions;
}

function buildQuery(component, dependencyTree, queryList, queryOptions) {
  var queryObj = null;
  var options = null;

  if (component in dependencyTree) {
    queryObj = getQuery(dependencyTree[component], queryList);
    options = getExternalQueryOptions(dependencyTree[component], queryOptions, component);
  }

  return {
    queryObj: queryObj,
    options: options
  };
}

function pushToAndClause(reactProp, component) {
  var react = _extends({}, reactProp);

  if (react.and) {
    if (Array.isArray(react.and)) {
      react.and = [].concat(_toConsumableArray(react.and), [component]);
      return react;
    } else if (typeof react.and === 'string') {
      react.and = [react.and, component];
      return react;
    }

    react.and = pushToAndClause(react.and, component);
    return react;
  }

  return _extends({}, react, {
    and: component
  });
}

function checkValueChange(componentId, value, beforeValueChange, performUpdate) {
  var selectedValue = value;

  if (Array.isArray(value) && !value.length) {
    selectedValue = null;
  }

  if (beforeValueChange) {
    beforeValueChange(selectedValue).then(performUpdate).catch(function (e) {
      console.warn(componentId + ' - beforeValueChange rejected the promise with ', e);
    });
  } else {
    performUpdate();
  }
}

function getAggsOrder(sortBy) {
  if (sortBy === 'count') {
    return {
      _count: 'desc'
    };
  }

  return {
    _term: sortBy
  };
}

var checkPropChange = exports.checkPropChange = function checkPropChange(prevProp, nextProp, callback) {
  if (!isEqual(prevProp, nextProp)) {
    callback();
    return true;
  }

  return false;
};

var checkSomePropChange = exports.checkSomePropChange = function checkSomePropChange(prevProps, nextProps, propsList, callback) {
  propsList.some(function (prop) {
    return checkPropChange(prevProps[prop], nextProps[prop], callback);
  });
};

var getClassName = exports.getClassName = function getClassName(classMap, component) {
  return classMap && classMap[component] || '';
};

var getInnerKey = exports.getInnerKey = function getInnerKey(obj, key) {
  return obj && obj[key] || {};
};

var handleA11yAction = exports.handleA11yAction = function handleA11yAction(e, callback) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback();
  }
};

var highlightResults = function highlightResults(result) {
  var data = _extends({}, result);

  if (data.highlight) {
    Object.keys(data.highlight).forEach(function (highlightItem) {
      var highlightValue = data.highlight[highlightItem][0];
      data._source = _extends({}, data._source, _defineProperty({}, highlightItem, highlightValue));
    });
  }

  return data;
};

var parseHits = exports.parseHits = function parseHits(hits) {
  var results = null;

  if (hits) {
    results = [].concat(_toConsumableArray(hits)).map(function (item) {
      var streamProps = {};

      if (item._updated) {
        streamProps._updated = item._updated;
      } else if (item._deleted) {
        streamProps._deleted = item._deleted;
      }

      var data = highlightResults(item);
      var result = Object.keys(data).filter(function (key) {
        return key !== '_source';
      }).reduce(function (obj, key) {
        obj[key] = data[key];
        return obj;
      }, _extends({
        highlight: data.highlight || {}
      }, data._source, streamProps));
      return result;
    });
  }

  return results;
};

function formatDate(date, props) {
  if (props.parseDate) {
    return props.parseDate(date, props);
  }

  switch (props.queryFormat) {
    case 'epoch_millis':
      return date.getTime();

    case 'epoch_seconds':
      return Math.floor(date.getTime() / 1000);

    default:
      {
        if (_dateFormats2.default[props.queryFormat]) {
          return date.toString(_dateFormats2.default[props.queryFormat]);
        }

        return date.getTime();
      }
  }
}

var getOptionsFromQuery = function getOptionsFromQuery() {
  var customQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (customQuery) {
    var query = customQuery.query,
        rest = _objectWithoutProperties(customQuery, ['query']);

    return Object.keys(rest).length ? rest : null;
  }

  return null;
};

exports.getOptionsFromQuery = getOptionsFromQuery;

var getSearchState = exports.getSearchState = function getSearchState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var selectedValues = state.selectedValues,
      queryLog = state.queryLog,
      dependencyTree = state.dependencyTree,
      props = state.props,
      hits = state.hits,
      aggregations = state.aggregations,
      isLoading = state.isLoading,
      error = state.error;
  var searchState = {};

  var populateState = function populateState() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = arguments[1];
    return Object.keys(obj).forEach(function (componentId) {
      searchState[componentId] = _extends({}, searchState[componentId], key ? _defineProperty({}, key, obj[componentId]) : obj[componentId]);
    });
  };

  populateState(props);
  Object.keys(selectedValues).forEach(function (componentId) {
    var componentState = searchState[componentId];
    var selectedValue = selectedValues[componentId];

    if (selectedValue) {
      searchState[componentId] = _extends({}, componentState, _extends({
        title: selectedValue.label,
        componentType: selectedValue.componentType,
        value: selectedValue.value
      }, selectedValue.category && {
        category: selectedValue.category
      }, {
        URLParams: selectedValue.URLParams
      }));
    }
  });

  if (!forHeaders) {
    populateState(queryLog);
    populateState(hits, 'hits');
    populateState(aggregations, 'aggregations');
    populateState(isLoading, 'isLoading');
    populateState(error, 'error');
  }

  populateState(dependencyTree, 'react');
  return searchState;
};

var updateInternalQuery = exports.updateInternalQuery = function updateInternalQuery(componentId, queryOptions, value, props, defaultQueryToExecute, queryParams) {
  var defaultQuery = props.defaultQuery;
  var defaultQueryOptions = void 0;
  var query = void 0;

  if (defaultQuery) {
    var queryTobeSet = defaultQuery(value, props);

    var _ref2 = queryTobeSet || {};

    query = _ref2.query;
    defaultQueryOptions = getOptionsFromQuery(queryTobeSet);
  }

  props.setQueryOptions(componentId, _extends({}, defaultQueryOptions, queryOptions || defaultQueryToExecute));

  if (query) {
    props.updateQuery(_extends({
      componentId: componentId,
      query: query
    }, queryParams));
  }
};

var extractQueryFromDefaultQuery = function extractQueryFromDefaultQuery(defaultQuery) {
  var queryToBeReturned = {};

  if (defaultQuery) {
    var evaluateQuery = defaultQuery();

    if (evaluateQuery) {
      var query = evaluateQuery.query,
          options = _objectWithoutProperties(evaluateQuery, ['query']);

      if (options) {
        queryToBeReturned = options;
      }
    }
  }

  return queryToBeReturned;
};

exports.extractQueryFromDefaultQuery = extractQueryFromDefaultQuery;

var getAggsQuery = exports.getAggsQuery = function getAggsQuery(query, props) {
  var clonedQuery = query;
  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing,
      missingLabel = props.missingLabel;
  clonedQuery.size = 0;
  clonedQuery.aggs = _defineProperty({}, dataField, {
    terms: _extends({
      field: dataField,
      size: size,
      order: getAggsOrder(sortBy || 'count')
    }, showMissing ? {
      missing: missingLabel
    } : {})
  });

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props.defaultQuery));
};

var getCompositeAggsQuery = exports.getCompositeAggsQuery = function getCompositeAggsQuery(query, props, after) {
  var showTopHits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var clonedQuery = query;
  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing,
      aggregationField = props.aggregationField;
  var finalField = aggregationField || dataField;
  var order = sortBy === 'count' ? {} : {
    order: sortBy
  };
  clonedQuery.aggs = _defineProperty({}, finalField, _extends({
    composite: _extends({
      sources: [_defineProperty({}, finalField, {
        terms: _extends({
          field: finalField
        }, order, showMissing ? {
          missing_bucket: true
        } : {})
      })],
      size: size
    }, after)
  }, showTopHits ? {
    aggs: _defineProperty({}, finalField, {
      top_hits: {
        size: 1
      }
    })
  } : {}));
  clonedQuery.size = 0;

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props.defaultQuery));
};